// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardGridConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  NUMBER_COLS: 12,
  NUMBER_ROWS: 5,
  GRID_CELL_SIZE: 90,
  DEFAULT_TILE_WIDTH: 12,
  DEFAULT_TILE_HEIGHT: 4,
  DEFAULT_TILE_HEIGHT_MOBILE: 400,
  TILE_MAX_HEIGHT: 440,
  get DELETE_CONFIRM_MESSAGE() {
    return localizer.getText('DASHBOARD_GRID_CONSTANTS_DELETE_CONFIRM_MESSAGE');
  },
  get DELETE_ICON_TOOLTIP() {
    return localizer.getText('COMMON_LABEL_DELETE');
  },
  get DUPLICATE_MESSAGE() {
    return localizer.getText('DASHBOARD_GRID_CONSTANTS_DUPLICATE_MESSAGE');
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.DashboardGridConstants.js